import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'
import { debug as logDebug } from '../utils/logger'
import { ResponseGetWall } from './interfaces/posts.interface/posts.getwall.interface'
import { error as logError } from '../utils/logger'
import { getAuthToken } from '../utils/functions.utils'

interface PropsGetWall {
    authToken: string
    version?: string | null
    page?: string | null
    size?: string | null
    retries?: number
    timeout?: number
}

export const request_get_wall = async ({ authToken, version, page, size, retries = 2, timeout = 10 }: PropsGetWall) => {
    const URL = apiUrl + '/get_wall'
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: authToken,
            version: version,
            page: page,
            size: size,
        }
        let data = await sendRequest(URL, 'GET', headers, null, retries, timeout, null, [], false)
        // console.log('📡 [request_get_wall] Raw data received:', JSON.stringify(data).substring(0, 500))
        // 🔍 DEBUG: Verificar primer post del backend
        if (data?.single?.data && data.single.data.length > 0) {
            console.log('🔍 [request_get_wall] Primer post del backend:')
            console.log('  - _id:', data.single.data[0]._id)
            console.log('  - title:', data.single.data[0].title?.substring(0, 50))
            console.log('  - medias length:', data.single.data[0].medias?.length || 0)
            if (data.single.data[0].medias && data.single.data[0].medias.length > 0) {
                // console.log('  - primera media:', JSON.stringify(data.single.data[0].medias[0]))
            } else {
                console.log('  - ⚠️ MEDIAS VACÍO O UNDEFINED EN BACKEND')
            }
        }
        if (
            !data?.response &&
            data &&
            'error' in data &&
            typeof (data as any).error === 'string' &&
            (((data as any).error as string).includes('NotAuthorizedException') ||
                ((data as any).error as string).includes('Unauthenticated access'))
        ) {
            // Intento de recuperación: refrescar token silenciosamente y reintentar una vez
            const newToken = await getAuthToken('posts_service_retry')
            if (newToken) {
                const retryHeaders = { ...headers, Authorization: newToken }
                data = await sendRequest(URL, 'GET', retryHeaders, null, retries, timeout, null, [], false)
                // console.log('📡 [request_get_wall] Retry data received:', JSON.stringify(data).substring(0, 500))
            }
        }
        // console.log('📡 [request_get_wall] Returning response:', JSON.stringify(data?.response).substring(0, 500))
        return data?.response
    } catch (err) {
        logError('PostsService', 'request_get_wall failed', err)
    }
}

interface PropsGetTermsAndContions {
    authToken: string
    // version?: string | null
    post_ids?: string
}
interface PropsAddFavourite {
    authToken: string
    post_id?: string
}

export const request_get_terms_and_conditions = async ({ authToken }: PropsGetTermsAndContions) => {
    const URL = apiUrl + '/get_terms_and_conditions'
    try {
        const headers = {
            Authorization: authToken,
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
        try { logDebug('TTCC', 'request_get_terms_and_conditions (service) req', { URL, hasAuth: !!authToken }) } catch {}
        let data = await sendRequest(URL, 'GET', headers, null, 0, 5, null, [], false)
        if (
            (!data?.response || data?.status !== 200) &&
            data &&
            'error' in data &&
            typeof (data as any).error === 'string' &&
            (((data as any).error as string).includes('NotAuthorizedException') ||
                ((data as any).error as string).includes('Unauthenticated access') ||
                ((data as any).error as string).includes('401'))
        ) {
            const newToken = await getAuthToken('ttcc_service_retry')
            if (newToken) {
                const retryHeaders = { ...headers, Authorization: newToken }
                data = await sendRequest(URL, 'GET', retryHeaders, null, 0, 5, null, [], false)
            }
        }
        try { logDebug('TTCC', 'request_get_terms_and_conditions (service) resp', { hasResponse: !!data, keys: Object.keys(data || {}) }) } catch {}
        return data.response
    } catch (err) {
        logError('PostsService', 'request_get_terms_and_conditions failed', err)
    }
}

export const request_get_reactions_wall_according_id = async ({ authToken, post_ids }: PropsGetTermsAndContions) => {
    const URL = apiUrl + '/get_reactions_wall_according_id'
    try {
        const headers = {
            Authorization: authToken,
            post_ids: JSON.stringify(post_ids),
        }
        let data = await sendRequest(URL, 'GET', headers, null, 0, 120)
        if (
            (!data?.response || data?.status !== 200) &&
            data &&
            'error' in data &&
            typeof (data as any).error === 'string' &&
            (((data as any).error as string).includes('NotAuthorizedException') ||
                ((data as any).error as string).includes('Unauthenticated access') ||
                ((data as any).error as string).includes('401'))
        ) {
            const newToken = await getAuthToken('reactions_service_retry')
            if (newToken) {
                const retryHeaders = { ...headers, Authorization: newToken }
                data = await sendRequest(URL, 'GET', retryHeaders, null, 0, 120)
            }
        }
        // const data = await sendRequest(URL, 'GET', headers, null, 0, 120, null, [], false)
        return data.response
    } catch (err) {
        logError('PostsService', 'get_reactions_wall_according_id failed', err)
    }
}

interface PropsGetPost {
    authToken: string
    post_id: string
}

export const request_get_post = async ({ authToken, post_id }: PropsGetPost) => {
    const URL = apiUrl + '/get_post'
    try {
        const headers: Record<string, string> = {
            Authorization: authToken,
            post_id: post_id,
        }
        let data = await sendRequest(URL, 'GET', headers, null, 1, 10)
        if (
            (!data?.response || data?.status !== 200) &&
            data &&
            'error' in data &&
            typeof (data as any).error === 'string' &&
            (((data as any).error as string).includes('NotAuthorizedException') ||
                ((data as any).error as string).includes('Unauthenticated access') ||
                ((data as any).error as string).includes('401'))
        ) {
            const newToken = await getAuthToken('post_service_retry')
            if (newToken) {
                const retryHeaders = { ...headers, Authorization: newToken }
                data = await sendRequest(URL, 'GET', retryHeaders, null, 1, 10)
            }
        }
        return data?.response
    } catch (err) {
        logError('PostsService', 'request_get_post failed', err)
    }
}

export const request_add_favourite = async ({ authToken, post_id }: PropsAddFavourite) => {
    const URL = apiUrl + '/add_favourite'
    try {
        const headers = {
            Authorization: authToken,
            post_id: post_id,
        }
        let data = await sendRequest(URL, 'POST', headers, null, 0, 120, null, [], false)
        if (
            (!data?.response || data?.status !== 200) &&
            data &&
            'error' in data &&
            typeof (data as any).error === 'string' &&
            (((data as any).error as string).includes('NotAuthorizedException') ||
                ((data as any).error as string).includes('Unauthenticated access') ||
                ((data as any).error as string).includes('401'))
        ) {
            const newToken = await getAuthToken('reactions_service_retry')
            if (newToken) {
                const retryHeaders = { ...headers, Authorization: newToken }
                data = await sendRequest(URL, 'POST', retryHeaders, null, 0, 120)
            }
        }
        // const data = await sendRequest(URL, 'GET', headers, null, 0, 120, null, [], false)
        return data.response
    } catch (err) {
        logError('PostsService', 'get_reactions_wall_according_id failed', err)
    }
}
